const convertTimeBound = seconds => {
  if (seconds === 0) {
    return 0
  }
  const days = Math.floor(seconds / (3600 * 24))
  return days
}

export default convertTimeBound
